var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Reorder Tables")]),_c('v-card-subtitle',[_vm._v("Sort tables to change in what order they appear in the calendar")]),_c('v-card-actions',[_c('v-btn',{staticClass:"primary",attrs:{"block":"","large":"","disabled":""}},[_vm._v(" Save ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }